export default __webpack_public_path__ + "static/media/seguridad.3f0e366b.png";